import React from 'react';
// import { render } from 'react-dom';
import { App } from './App';
import 'bootstrap/dist/css/bootstrap.min.css';

import ReactDOM from 'react-dom/client';


// render(<App />, document.getElementById('root'));
const root = ReactDOM.createRoot(document.getElementById('root')); // Create a root
root.render(<App />); // Render your application


